module.exports = __webpack_public_path__ + "media/images/pergolen-b2efb215e01180b6805ae7e0aeee5eb3.jpg";